import { render, staticRenderFns } from "./DokmanComponentFreigabeFreigabe.vue?vue&type=template&id=c721315e&scoped=true"
import script from "./DokmanComponentFreigabeFreigabe.vue?vue&type=script&lang=js"
export * from "./DokmanComponentFreigabeFreigabe.vue?vue&type=script&lang=js"
import style0 from "./DokmanComponentFreigabeFreigabe.vue?vue&type=style&index=0&id=c721315e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c721315e",
  null
  
)

export default component.exports